module.exports = __webpack_public_path__ + "img/sobre.e6d2225a.jpg";